import React, { useState, useEffect } from "react";
import { postAPI } from "../../ApiService";
import { NavLink } from "react-router-dom";
import { getProfile } from "../../Api/Auth";
import {
  getStoredUserDetail,
  DEFAULT_USER_AVATAR,
  getUserDisplayName,
  getUserAvatar,
  saveUserDetail,
} from "../../utils/userProfile";

function Header() {
  const [userDetail, setUserDetail] = useState(() => getStoredUserDetail());
  const [mobileNav, setMobileNav] = useState(false);
  const [avatarSrc, setAvatarSrc] = useState(() =>
    getUserAvatar(getStoredUserDetail())
  );

  useEffect(() => {
    const checkLogin = localStorage.getItem("token");
    if (!checkLogin) {
      window.location.href = "/";
      return;
    }

    let cancelled = false;
    getProfile().then((res) => {
      if (cancelled || res.status !== 1) return;
      const stored = getStoredUserDetail() || {};
      const nextUser = {
        ...stored,
        ...res.payload,
        token: stored.token,
      };
      saveUserDetail(nextUser);
      setUserDetail(nextUser);
      setAvatarSrc(getUserAvatar(nextUser));
    });

    return () => {
      cancelled = true;
    };
  }, []);

  const logout = async () => {
    const res = await postAPI("/auth/logout", {});
    if (res.status === 1) {
      localStorage.clear();
      window.location.href = "/";
    }
  };

  const toggleMobileNav = () => {
    const menu = document.getElementsByClassName("app-menu")[0];
    if (!menu) return;
  if (mobileNav === false) {
      menu.style.marginLeft = "-100%";
    } else {
      menu.style.marginLeft = "0px";
    }
    setMobileNav(!mobileNav);
  };

  useEffect(() => {
    if (window.innerWidth <= 767.98) {
      toggleMobileNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const displayName = getUserDisplayName(userDetail);
  const onAvatarError = (e) => {
    e.target.onerror = null;
    e.target.src = DEFAULT_USER_AVATAR;
  };

  return (
    <>
      <div id="layout-wrapper">
        <header id="page-topbar">
          <div className="layout-width">
            <div className="navbar-header">
              <div className="d-flex" style={{ alignItems: "center" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="70"
                  height="30"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                  className="hamburger-btn"
                  onClick={toggleMobileNav}
                >
                  <path
                    fillRule="evenodd"
                    d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
                  />
                </svg>
                <div className="navbar-brand-box">
                  <NavLink to={"/projects?status=active"} className="logo logo-light">
                    <span className="logo-sm">
                      <img src="assets/images/favi.png" alt="" height="40" />
                    </span>
                    <span className="logo-lg">
                      <img
                        src="assets/images/logo-big.png"
                        alt=""
                        height="47"
                      />
                    </span>
                  </NavLink>
                </div>
              </div>

              <div className="d-flex align-items-center">
                <div className="dropdown ms-sm-3 header-item topbar-user">
                  <button
                    type="button"
                    className="btn"
                    id="page-header-user-dropdown"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{ backgroundColor: "white" }}
                  >
                    <span className="d-flex align-items-center">
                      <img
                        className="rounded-circle header-profile-user"
                        src={avatarSrc}
                        alt={displayName}
                        onError={onAvatarError}
                      />
                      <span className="text-start ms-xl-2">
                        <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                          {displayName}
                        </span>
                        {userDetail?.email ? (
                          <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                            {userDetail.email}
                          </span>
                        ) : null}
                      </span>
                    </span>
                  </button>
                  <div className="dropdown-menu dropdown-menu-end">
                    <span className="d-flex align-items-center dropdown-item bg-primary">
                      <img
                        className="rounded-circle header-profile-user"
                        src={avatarSrc}
                        alt={displayName}
                        onError={onAvatarError}
                      />
                      <span className="text-start ms-xl-2">
                        <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text-p color-white">
                          {displayName}
                        </span>
                        {userDetail?.email ? (
                          <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text-p user-name-text-p">
                            {userDetail.email}
                          </span>
                        ) : null}
                      </span>
                    </span>

                    <NavLink className="dropdown-item" to="/profile">
                      <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                      <span className="align-middle">Profile</span>
                    </NavLink>
                    <div className="dropdown-divider"></div>
                    <button
                      type="button"
                      className="dropdown-item"
                      onClick={logout}
                    >
                      <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
                      <span className="align-middle" data-key="t-logout">
                        Logout
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>
    </>
  );
}

export default Header;
